// @flow
import React from 'react';

import { ButtonLink } from '../../../ButtonLink';

type Props = {
  dataTestId: string,
  planType: number,
};

export const OrderNowButton = ({
  dataTestId,
  planType,
  ...rest
}: Props) => (
  <ButtonLink
    to="#"
    bg="gray"
    textProps={{
      color: 'white',
      fontWeight: 'bold',
      fontFamily: 'bodyMuli',
    }}
    color="white"
    mb={0}
    fontWeight="bold"
    fontFamily="bodyMuli"
    hover
    {...rest}
    data-testid={dataTestId}
  >
    Sold Out
  </ButtonLink>
);
